<template>
    <modal size="lg" @close="$emit('close')" ref="modal" :is-closeable="isCloseable" :autoshow="true">
        <template v-slot:title>
            Edit Earning Type
        </template>
        <slot>
            <form-errors :errors="formErrors"/>

            <div class="mb-3 p-1 unpad-x bg-150 rounded">
                <div><span class="text-muted">Base Earning Type: </span>{{ earning.earning_type.name }}</div>
                <div><span class="text-muted">Name: </span>{{ earning.name }}</div>
            </div>

            <form class="mui-form" @submit.prevent="onSubmit()">
                <div class="form-row" v-if="canCustomize('name')">
                    <div class="col">
                        <form-input v-model="formData.name" :errors="errors.name" type="text" label="Name" />
                    </div>
                </div>

                <div class="form-row" v-if="canCustomize('type')">
                    <div class="col">
                        <form-input v-model="formData.type" :errors="errors.type" type="select" label="Type" :options="typeOptions" />
                    </div>
                </div>

                <div class="form-row mb-2" v-if="canCustomize('is_work_suffered')">
                    <div class="col">
                        <form-input v-model="formData.is_work_suffered" :errors="errors.is_work_suffered" type="checkbox" label="Is Work Suffered" />
                    </div>
                </div>

                <div class="form-row mb-2" v-if="canCustomize('symmetry_wage_type_supplemental_treatment')">
                    <div class="col">
                        <form-input v-model="formData.symmetry_wage_type_supplemental_treatment" :errors="errors.symmetry_wage_type_supplemental_treatment" type="checkbox" label="Supplemental Treatment" />
                    </div>
                </div>

                <div class="form-row mb-2" v-if="canCustomize('is_virtual')">
                    <div class="col">
                        <form-input v-model="formData.is_virtual" :errors="errors.is_virtual" type="checkbox" label="Is Virtual" />
                    </div>
                </div>

                <div class="form-row mb-2" v-if="canCustomize('is_cash_tips')">
                    <div class="col">
                        <form-input v-model="formData.is_cash_tips" :errors="errors.is_cash_tips" type="checkbox" label="Is Cash Tips" />
                    </div>
                </div>

                <template v-if="effectiveType === 'hourly'">
                    <div class="form-row mb-2">
                        <div class="col">
                            <form-input v-model="formData.is_tied_to_base_rate" :errors="errors.is_tied_to_base_rate" type="checkbox" label="Is Tied to Base Rate" />
                        </div>
                    </div>

                    <template v-if="formData.is_tied_to_base_rate">
                        <div class="form-row">
                            <div class="col-6">
                                <form-input v-model="formData.base_rate_multiplier" :errors="errors.base_rate_multiplier" type="number" label="Base Rate Multiplier" />
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="col-6">
                                <form-input v-model="formData.base_rate_addition" :errors="errors.base_rate_addition" type="number" label="Base Rate Addition" />
                            </div>
                        </div>
                    </template>
                </template>
            </form>
        </slot>

        <template v-slot:footer>
            <button-row>
                <button type="button" class="btn btn-block btn-outline-primary" @click.prevent="close()">Cancel</button>
                <button type="button" class="btn btn-block btn-primary" @click.prevent="onSubmit()">Save</button>
            </button-row>
        </template>
    </modal>
</template>

<script>
import FormMixin from '@/mixins/Form'
import ModalMixin from '@/mixins/ModalMixin'

export default {
    props: ['earning', 'client', ],
    mixins: [FormMixin, ModalMixin, ],
    data() {
        return {
            formData: this.makeFormData(),
        }
    },
    computed: {
        typeOptions() {
            return [
                {text: 'Hourly', value: 'hourly'},
                {text: 'Per Unit', value: 'per-unit'},
                {text: 'Amount', value: 'amount'},
            ]
        },
        effectiveType() {
            if (this.canCustomize('type')) {
                return this.formData.type
            }
            return this.earning?.earning_type?.type
        },
    },
    methods: {
        canCustomize(fieldName) {
            return this.earning?.earning_type?.fields_to_customize?.includes(fieldName) || false
        },
        makeFormData() {
            return {
                name: this.earning?.name || '',
                type: this.earning?.type || 'hourly',
                is_work_suffered: this.earning?.is_work_suffered || false,
                symmetry_wage_type_supplemental_treatment: this.earning?.symmetry_wage_type_supplemental_treatment || false,
                is_virtual: this.earning?.is_virtual || false,
                is_cash_tips: this.earning?.is_cash_tips || false,
                is_tied_to_base_rate: this.earning?.is_tied_to_base_rate || false,
                base_rate_multiplier: this.earning?.base_rate_multiplier || '1.00',
                base_rate_addition: this.earning?.base_rate_addition || '0.00',
            }
        },
        getFormData() {
            return this.formData
        },
        onSubmit() {
            this.$store.dispatch('START_LOADING')
            this.errors = {}
            this.formErrors = []
            return this.$api.put(`/clients/${this.client.id}/settings/earning-types/${this.earning.id}`, this.getFormData()).then(resp => {
                this.$store.dispatch('STOP_LOADING')
                this.$emit('updated', resp)
                this.close()
            }).catch(errors => {
                this.$store.dispatch('STOP_LOADING')
                this.errors = errors
                this.formErrors = errors.__all__
                this.onError()
            })
        },
    }
}
</script>
